import { render, staticRenderFns } from "./CwpeSettings.vue?vue&type=template&id=0a813a80&"
import script from "./CwpeSettings.vue?vue&type=script&lang=js&"
export * from "./CwpeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports